import { matchPath } from 'react-router-dom'

// import {
//   fetchProductStoreRequest
// } from './actionCreators/productStore/productStoreActionCreators'

export const pdp0 = {
  path: '/product/:partNumber'
  // fetch: () => fetchProductStoreRequest(),
  // analytics: {
  //   pageName: 'DEMO:',
  //   loadEvent: 'page_1_loaded',
  // },
  // pageTitle: 'Demo Page 1',
}

export const specialoffers = {
  path: '/product/:partNumber/specialoffers/:promotionId'
  // analytics: {
  //   pageName: 'DEMO 2:',
  //   loadEvent: 'page_2_loaded',
  // },
  // pageTitle: 'Demo Page 2',
}

export const questions = {
  path: '/product/:partNumber/questions'
}

export const reviews = {
  path: '/product/:partNumber/reviews'
}

// Adding a new route? Make sure it has analytics!
export const routes = [pdp0, specialoffers, questions, reviews]

// Returns the `route` config for a given path
export const getRoute = path => routes.find(route => matchPath(path, route))

// Triggers the action associated with a route. Used for SSR to
// wait for actions to complete before rendering the page.
export const processRoutes = (store, req) => {
  routes.some(route => {
    const match = matchPath(req.path, route)
    if (match && typeof route.fetch === 'function') {
      store.dispatch(route.fetch(match, req))
    }
    return match
  })
}

// Returns the pageTitle for a given route
export const getPageTitle = path => (getRoute(path) && getRoute(path).pageTitle) || 'Demo App'
